<template>
    <div>
        <tab name="2"></tab>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input
                        placeholder="请输入角色名称"
                        v-model="params.roleName"
                        size="small"
                    ></el-input>
                </el-col>
                <el-col
                    :xs="24"
                    :sm="12"
                    :md="8"
                    :lg="8"
                    :xl="4"
                    class="page-filter-btns"
                >
                    <el-button
                        type="primary"
                        icon="el-icon-search"
                        @click="search"
                        size="small"
                        >查询</el-button
                    >
                    <el-button
                        type="default"
                        icon="el-icon-refresh"
                        @click="reset"
                        size="small"
                        >重置</el-button
                    >
                </el-col>
            </el-row>
        </div>
        <div v-if="$utils.have('/suduRole/add')" class="page-btns-box">
            <el-button
                type="primary"
                icon="el-icon-plus"
                @click="$router.push('/system/fb/role/add')"
                size="small"
                >创建角色</el-button
            >
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="roleName" label="角色"></el-table-column>
                <el-table-column prop="description" label="备注"></el-table-column>
                <!-- <el-table-column
                    prop="createTime"
                    label="创建时间"
                ></el-table-column> -->
                <el-table-column fixed="right" label="操作" width="120">
                    <template slot-scope="scope">
                        <el-button
                            v-if="$utils.have('/suduRole/edit')"
                            type="text"
                            size="small"
                            icon="el-icon-edit"
                            @click="edit(scope.row.id)"
                            >编辑</el-button
                        >
                        <el-button
                            v-if="$utils.have('/suduRole/delete')"
                            type="text"
                            size="small"
                            icon="el-icon-delete"
                            @click="del(scope.row.id)"
                            >删除</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0"
            >
            </el-pagination>
        </div>
    </div>
</template>
<script>
import tab from '../components/tab.vue'
const defaultParams = {
    pageNo:1,
    roleName:''
}
export default {
    components: { tab },
    data() {
        return {
            data: null,
            dataList: null,
            params: {
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                roleName: this.$route.query.roleName || "",
            },
            listLoading: true,
        };
    },
    mounted() {
        this.getDataList();
    },
    methods: {
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/suduRole/pageList",
                method: "POST",
                data: this.params,
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        //编辑
        edit(id) {
            this.$router.push({
                path: `/system/fb/role/edit/${id}`,
                query: {
                    redirect: this.$utils.objArgs(
                        this.$router.currentRoute.path,
                        this.params
                    ),
                },
            });
        },
        //删除事件
        del(id){
            this.$confirm('确定要删除吗?', '提示', {
                type: 'warning',
                center: true,
                closeOnClickModal: false
            }).then(() => {
                this.listLoading = true;
                this.$request({
                    url: '/suduRole/delete',
                    method: 'POST',
                    data: {id:id}
                }).then(res => {
                    const { state, msg } = res.data;
                    if( state == 1 ){
                        this.getDataList();
                    }else{
                        this.$message.error(msg || '请求失败');
                    }
                }).catch(() => {
                    this.$message.error('请求错误');
                }).finally(() => {
                    this.listLoading = false;
                });
            })
        }
    },
};
</script>